import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminStateService {
  private isAdminSubject = new BehaviorSubject<boolean>(false);
  public isAdmin$: Observable<boolean> = this.isAdminSubject.asObservable();

  constructor() { }

  setAdminState(isAdmin: boolean): void {
    this.isAdminSubject.next(isAdmin);
  }

  getAdminState(): boolean {
    return this.isAdminSubject.value;
  }
}